<template>
  <div @contextmenu.prevent.stop="onContextmenu">
    <sj-question-file :disabled="disabled">
      <draggable
        :list="files"
        :options="{disabled: disabled}">
        <sj-question-file-item
          v-for="(file, index) in files"
          :key="index"
          :poster="file.src"
          :disabled="disabled"
          @click.stop.native="onCheck(index)"
          @contextmenu.prevent.stop.native="(event)=>{onContextmenu(event, index)}"
          @remove="remove(index)"
          :selected="checkedFiles.includes(file)"></sj-question-file-item>
      </draggable>

      <el-tooltip
        effect="dark"
        content="添加图片"
        placement="top">
        <sj-question-file-add :disabled="disabled"
                              @click="upload"></sj-question-file-add>
      </el-tooltip>
    </sj-question-file>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import SjQuestionFile from '@/views/question-editor/packages/sj-question-file'
import SjQuestionFileItem from '@/views/question-editor/packages/sj-question-file-item'
import SjQuestionFileAdd from '@/views/question-editor/packages/sj-question-file-add'
import ContextMenu from '@/views/question-review/components/ContextMenu'

export default {
  components: {SjQuestionFileAdd, SjQuestionFileItem, SjQuestionFile, draggable},
  mixins: [],
  inject: ['playImage', 'uploadImage'],
  props: {
    value: Array,
    disabled: Boolean,
  },
  data () {
    return {
      checkMode: false,
      uniqueId: _.uniqueId(),
      checkedFiles: [],
      uploadApi: 'uploadStepTemplateFile'
    }
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    isMacOS () {
      return navigator.platform.indexOf('Mac') === 0
    },
    controlKeyCode () {
      return this.isMacOS ? 91 : 17
    },
  },
  watch: {},
  created () {
    this.addEventListener()
  },
  mounted () {
    ContextMenu({
      uploadApi: this.uploadApi
    }, true).appendElement('.step-template-content-container')
  },
  destroyed () {
    this.removeEventListener()
  },
  methods: {
    onCheck (index) {
      ContextMenu().hide()
      if (this.checkMode) {
        ContextMenu().setScope(this.uniqueId)
        ContextMenu().checked(this.files[index])
        this.checkedFiles = ContextMenu().checkedFiles
      } else {
        this.onView(index)
      }
    },
    onView (index) {
      this.playImage(this.value, index)
    },
    upload () {
      this.uploadImage((file) => {
        let form = new FormData()
        form.append('file', file)
        return request(this.uploadApi, form).then(({data}) => {
          this.files.push({type: 'photo', src: data})
        })
      })
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    onContextmenu ({clientX, clientY}, index) {
      // 匹配右击菜单作用域
      ContextMenu().scope !== this.uniqueId && ContextMenu().empty()
      // 判断右击是否在项目上
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        if (!this.checkedFiles.includes(file)) {
          ContextMenu().empty()
          ContextMenu().checked(file)
          this.checkedFiles = ContextMenu().checkedFiles
        }
      } else {
        ContextMenu().empty()
      }
      // 限制拷贝数量
      ContextMenu({pasteMax: Number.MAX_SAFE_INTEGER})
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)
    },
    addEventListener () {
      document.addEventListener('keydown', this.keydown)
      document.addEventListener('keyup', this.keyup)
      document.addEventListener('click', this.clickDoc)
      document.addEventListener('visibilitychange', this.visibilityChange)
    },
    removeEventListener () {
      document.removeEventListener('keydown', this.keydown)
      document.removeEventListener('keyup', this.keyup)
      document.removeEventListener('click', this.clickDoc)
      document.removeEventListener('visibilitychange', this.visibilityChange)
    },
    clickDoc () {
      ContextMenu().hide()
    },
    keyup (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = false
          break
      }
    },
    keydown (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = true
          break
      }
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/SjQuestionImage.vue